(function () {
  function getProgress(track) {
    const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
    const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 1;
    return {
      maxScroll: maxScroll,
      progress: maxScroll > 0 ? Math.max(ratio, 0.08) : 1
    };
  }

  function updateCategoryGrid(section) {
    const track = section.querySelector('.category-grid__track');
    const fill = section.querySelector('.category-grid__progress-fill');
    const arrows = section.querySelectorAll('.category-grid__arrow');

    if (!track || !fill) return;

    const state = getProgress(track);
    fill.style.width = (state.progress * 100) + '%';

    arrows.forEach(function (button) {
      const dir = parseInt(button.getAttribute('data-direction'), 10);
      if (dir === -1) {
        button.disabled = track.scrollLeft < 5;
      } else {
        button.disabled = state.maxScroll <= 0 || track.scrollLeft >= state.maxScroll - 5;
      }
    });
  }

  function bindCategoryGrid(section) {
    if (!section || section.dataset.categoryGridInitialized === 'true') return;

    const track = section.querySelector('.category-grid__track');
    const arrows = section.querySelectorAll('.category-grid__arrow');

    if (!track) return;

    section.dataset.categoryGridInitialized = 'true';

    function update() {
      updateCategoryGrid(section);
    }

    function scrollTrack(direction) {
      const tile = track.querySelector('.category-grid__tile');
      const tileWidth = tile ? tile.offsetWidth : 280;
      const gap = parseFloat(window.getComputedStyle(track).gap) || 24;
      track.scrollBy({ left: direction * (tileWidth + gap), behavior: 'smooth' });
    }

    track.addEventListener('scroll', update, { passive: true });

    arrows.forEach(function (button) {
      button.addEventListener('click', function () {
        const direction = parseInt(button.getAttribute('data-direction'), 10);
        scrollTrack(direction);
      });
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(function () {
        requestAnimationFrame(update);
      });

      observer.observe(track);

      track.querySelectorAll('img').forEach(function (img) {
        observer.observe(img);
      });
    } else {
      track.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', update, { once: true });
        }
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(update);
    });

    window.addEventListener('load', update, { once: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function initCategoryGrids(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.category-grid').forEach(function (section) {
      bindCategoryGrid(section);
      updateCategoryGrid(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCategoryGrids(document);
    }, { once: true });
  } else {
    initCategoryGrids(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCategoryGrids(event.target || document);
  });
})();
